<template>
<div>
<ul id="slide-out" class="sidenav">
    <li><div class="user-view">
      <div class="background">
        <img src="images/office.jpg">
      </div>
      <a href="#user"><img class="circle" src="images/yuna.jpg"></a>
      <a href="#name"><span class="white-text name">John Doe</span></a>
      <a href="#email"><span class="white-text email">jdandturk@gmail.com</span></a>
    </div></li>
    <li><a href="#!"><i class="material-icons">cloud</i>First Link With Icon</a></li>
    <li><a href="#!">Second Link</a></li>
    <li><div class="divider"></div></li>
    <li><a class="subheader">Subheader</a></li>
    <li><a class="waves-effect" href="#!">Third Link With Waves</a></li>
  </ul>
  <a href="#" data-target="slide-out" class="sidenav-trigger"><i class="material-icons">menu</i></a>
  </div>
<!--
    <div id="helpSidebar" class="z-depth-3" :class="{open: helpSidebarOpen}">
      <div v-if="!tutorialSelected" class="help-menu">
        <div class="help-logo">
          <img src="./../assets/fyiio-logo.svg" />
        </div>
        <h2>
          Hey there!
          <br />What can we help you do?
        </h2>
        <ol class="help-steps">
          <li
            class="z-depth-2"
            @click="selectTutorial('https://dashboard.fyiio.com/s/fSGKn7oR')"
          >Creating tutorials</li>
          <li
            class="z-depth-2"
            @click="selectTutorial('https://dashboard.fyiio.com/s/zzPEI5Kl')"
          >Sharing tutorials</li>
          <li
            class="z-depth-2"
            @click="selectTutorial('https://dashboard.fyiio.com/s/CdCe1JvS')"
          >Updating tutorials</li>
         
        </ol>
      </div>
      <div class="tutorial-wrap" v-if="tutorialSelected">
        <iframe
          v-bind:src="tutorialSelected"
          width="375"
          height="300"
          frameborder="0"
          allowfullscreen="allowfullscreen"
        ></iframe>
      </div>
    </div>
    -->
</template>
<script>
export default {
    props: [],
mounted() {},
  updated() {},
  name: "EditorNav",
  data() {
    return {
      helpSidebarOpen: false,
      tutorialSelected: false
    };
  },
  methods: {
    helpClick() {
      if (this.helpSidebarOpen) {
        this.tutorialSelected = false;
        $("#app").removeClass("sidebarOpen");
      } else {
        $("#app").addClass("sidebarOpen");
      }
      this.helpSidebarOpen = !this.helpSidebarOpen;
    },
    selectTutorial(tutorial) {
      this.tutorialSelected = tutorial;
    }
  }
};
</script>
<style scoped>
iframe {
  height: calc(100vh - 80px);
}
.tutorial-wrap {
  margin-top: -24px;
}
ol {
  list-style: none;
  counter-reset: item;
  padding: 0;
}
li {
  cursor: pointer;
  counter-increment: item;
  width: 350px;
  margin: 24px auto;
  height: 40px;
  line-height: 40px;
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
}
li:before {
  margin-right: 10px;
  width: 40px;
  text-align: center;
  content: counter(item);
  background: #616161;
  color: white;
  text-align: center;
  display: inline-block;
  line-height: 40px;
}
.help-steps li {
  color: black;
}
h2 {
  text-align: center;
  padding: 24px;
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  text-align: center;
  margin: 0;
}
.help-logo {
  margin-top: 24px;
  top: 24px;
  width: 100px;
  height: 100px;
  border-radius: 100px;
  border: 4px solid #58595b;
  text-align: center;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.help-logo img {
  height: 27px;
  width: 50px;
}
#helpSidebar {
  padding-top: 24px;
  position: absolute;
  right: -550px;
  width: 375px;
  min-height: calc(100vh - 65px);
  top: 65px;
  z-index: 1000;
  background: white;
  transition: all 0.25s ease-in;
}
#helpSidebar.open {
  right: calc(100vw-500px);
}
.help {
  cursor: pointer;
}
nav {
  padding: 0;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.nav-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding-left: 13px;
  padding-right: 13px;
  z-index: 10;
}
.nav-info {
  text-align: center;
}
.title {
  text-align: center;
  font-size: 20px;
  line-height: 28px;
  padding: 0;
}
.changes {
  text-align: center;
  font-size: 12px;
  line-height: 16px;
}
.material-icons {
  font-size: 24px;
}
i {
  margin-left: 25px;
  margin-right: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/HelpSidebar.vue